<organ-dynamic-tab-layout [options]="{desktopStyle: 2, mobileStyle: 1}" [tabs]="tabs"></organ-dynamic-tab-layout>
